import { render } from "./BillClientModal.vue?vue&type=template&id=05c18af6"
import script from "./BillClientModal.vue?vue&type=script&lang=js"
export * from "./BillClientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__